import { useRouter } from 'next/router';
import { useSelector } from 'react-redux';
import CustomTab from '../../Common/CustomTab';
import ScrollableWithArrows from '../../Common/ScrollableWithArrows';
import { Skeleton } from '../../Common/Skeleton';

export default function CategorySubNavbarComponent({
  categories,
  categoryTabHandler,
}) {
  const router = useRouter();
  const { categoryId, postType } = router.query;
  const highlightItem = useSelector(({ common }) => common?.highlightItem);
  const lang = useSelector(({ common }) => common?.language);
 
  const checkIsHighlighted = (item) => {
      
     if (categoryId && postType) {
      if(router?.pathname?.includes('/market')){
        return item?.id == categoryId || item?.id == postType;
      }
      else return item?.id == categoryId;
    } else if (categoryId) {
      return item?.id == categoryId;
    } else if (postType) {
      return item?.id == postType;
    } else if(highlightItem) {
      return item?.id == highlightItem;
    }
    else return false
  };


  return (
    <div className='relative border-b-[1px] border-border-mid bg-white md:flex md:justify-center'>
      <div className='custom-container relative flex items-center'>
        {categories ? (
          <ScrollableWithArrows>
            <CustomTab
              className='h-[58px]'
              tab={{ id: lang?.common?.home, name: lang?.common?.home }}
              isHighlighted={
                router?.pathname === '/community' ||
                router?.pathname === '/market'
              }
              onClickHandler={categoryTabHandler}
            />
            {categories.map((item, index) => (
              <CustomTab
                className='h-[58px]'
                key={index}
                tab={item}
                isHighlighted={checkIsHighlighted(item)}
                onClickHandler={categoryTabHandler}
              />
            ))}
          </ScrollableWithArrows>
        ) : (
          <div className='no-scrollbar flex h-[58px] w-full items-center gap-[43px] overflow-auto bg-white'>
            {Array.from({ length: 15 }).map((_, index) => (
              <div key={index}>
                <Skeleton className='h-[20px] w-[80px] rounded-sm' />
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}
